module.exports = __webpack_public_path__ + "img/energy-suppliers.39f049c.png";